import type { BookingLocale } from "@/i18n/types";

function intlLocale(locale: BookingLocale): string {
  return locale === "en" ? "en-GB" : "de-DE";
}

export function formatCurrency(
  amount: string | number | null | undefined,
  currency = "EUR",
  locale: BookingLocale = "de",
): string {
  if (amount == null || amount === "") return "—";
  const num = typeof amount === "string" ? Number(amount) : amount;
  if (Number.isNaN(num)) return "—";
  return new Intl.NumberFormat(intlLocale(locale), { style: "currency", currency }).format(num);
}

export function grossFromNet(net: number, taxRatePercent: number): number {
  return net * (1 + taxRatePercent / 100);
}

export function toAmountNumber(amount: string | number | null | undefined): number | null {
  if (amount == null || amount === "") return null;
  const num = typeof amount === "string" ? Number(amount) : amount;
  return Number.isFinite(num) ? num : null;
}

export function grossAmountFromNet(
  net: string | number | null | undefined,
  taxRatePercent: string | number,
): number | null {
  const n = toAmountNumber(net);
  if (n == null) return null;
  const rate = Number(taxRatePercent) || 0;
  return Math.round(grossFromNet(n, rate) * 100) / 100;
}

export function formatGrossFromNet(
  net: string | number | null | undefined,
  taxRatePercent: string | number,
  currency = "EUR",
  locale: BookingLocale = "de",
): string {
  const gross = grossAmountFromNet(net, taxRatePercent);
  if (gross == null) return "—";
  return formatCurrency(gross, currency, locale);
}

/** Brutto-Einzelpreis aus Positions-Bruttosumme und Menge. */
export function grossUnitPriceFromLine(
  lineTotal: string | number,
  quantity: string | number,
): number | null {
  const total = toAmountNumber(lineTotal);
  const qty = toAmountNumber(quantity);
  if (total == null || qty == null || qty <= 0) return null;
  return Math.round((total / qty) * 100) / 100;
}
